/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsplatformhint2Inputs */

const en_statsplatformhint2 = /** @type {(inputs: Statsplatformhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is on Pulsify right now.`)
};

const de_statsplatformhint2 = /** @type {(inputs: Statsplatformhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was gerade auf Pulsify zu finden ist.`)
};

/**
* | output |
* | --- |
* | "What is on Pulsify right now." |
*
* @param {Statsplatformhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsplatformhint2 = /** @type {((inputs?: Statsplatformhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsplatformhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsplatformhint2(inputs)
	return de_statsplatformhint2(inputs)
});
export { statsplatformhint2 as "statsPlatformHint" }